import { render } from "./ListagemSolucoes.vue?vue&type=template&id=7349f6c9"
import script from "./ListagemSolucoes.vue?vue&type=script&lang=js"
export * from "./ListagemSolucoes.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__